import { module } from 'modujs';
import { html } from '../utils/environment';
import gsap, { ScrollTrigger } from 'gsap/all';
import config from '../config';

gsap.registerPlugin(ScrollTrigger);

const CLASS = {
    OPEN: `has-menu-open`,
}

export default class extends module {
    constructor(m) {
        super(m);

        this.logo = this.$('logo')[0]
        this.filter = document.querySelector('.c-mobile_filter')

        this.events = {
            click: {
                'menu': 'openMenu',
                'top': 'scrollTop'
            }
        }

        setTimeout(() => {
            this.launch()
        }, 100)
    }

    launch() {
        this.contactPage = document.querySelector('#contact')

        if (config.IS_TOUCH || window.innerWidth < 700) {

            if (this.contactPage) {
                this.headerST = gsap.to(this.el, {
                    scrollTrigger: {
                        trigger: document.body,
                        id: "header",
                        start: "top -" + window.innerHeight / 5,
                        end: 'bottom top',
                        onEnter: () => {
                            this.el.classList.remove('is-reverse')
                        },
                        onLeaveBack: () => {
                            this.el.classList.add('is-reverse')
                        }
                    }
                })
            } else {
                this.headerST = gsap.to(this.el, {
                    scrollTrigger: {
                        trigger: document.body,
                        id: "header",
                        start: "top -" + window.innerWidth * 0.035,
                        end: '+=' + window.innerWidth * 0.035,
                        onEnter: () => {
                            if (!this.contactPage) this.el.classList.add('is-small')
                            if (this.filter) this.filter.classList.add('is-shown')
                        },
                        onLeaveBack: () => {
                            if (!this.contactPage) this.el.classList.remove('is-small')
                            if (this.filter) this.filter.classList.remove('is-shown')
                        }
                    }
                })
            }
        } else {
            if (this.contactPage) return;

            this.headerST = gsap.to(this.el, {
                scrollTrigger: {
                    trigger: document.body,
                    id: "header",
                    start: "top -" + window.innerWidth * 0.035,
                    end: '+=' + window.innerWidth * 0.035,
                    onEnter: () => {
                        if (!this.contactPage) this.el.classList.add('is-small')
                        if (this.filter) this.filter.classList.add('is-shown')
                    },
                    onLeaveBack: () => {
                        if (!this.contactPage) this.el.classList.remove('is-small')
                        if (this.filter) this.filter.classList.remove('is-shown')
                    }
                }
            })
        }

    }

    update() {
        if (this.headerST) {
            this.headerST.scrollTrigger.refresh()
        }
    }

    openMenu() {
        html.classList.add(CLASS.OPEN)
    }

    closeMenu() {
        html.classList.remove(CLASS.OPEN)
    }

    scrollTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    destroy() {
        super.destroy()
        if (this.headerST) this.headerST.scrollTrigger.refresh()
    }
}
